import React from 'react';
import { Link } from 'react-router-dom';
import { Shield, Phone, Mail, Clock, ArrowLeft } from 'lucide-react';

export function Warranty() {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto">
          <Link 
            to="/"
            className="inline-flex items-center text-gray-600 hover:text-gray-900 mb-8"
          >
            <ArrowLeft className="w-5 h-5 mr-2" />
            Back to Home
          </Link>

          <div className="bg-white rounded-lg shadow-md overflow-hidden">
            <div className="p-6 sm:p-8">
              <div className="flex items-center mb-6">
                <Shield className="w-8 h-8 text-blue-600 mr-3" />
                <h1 className="text-2xl sm:text-3xl font-bold text-gray-900">Warranty Information</h1>
              </div>

              <div className="prose max-w-none">
                <div className="bg-blue-50 rounded-lg p-6 mb-8">
                  <h2 className="text-xl font-semibold text-blue-900 mb-4">Warranty Coverage</h2>
                  <div className="space-y-4 text-blue-800">
                    <p>
                      If your dryer or washing machine breaks within the warranty period, we will replace it with a working unit—no refund.
                    </p>
                    <p>
                      If it breaks after warranty expires, you receive 50% off your next purchase (valid for 1 year after warranty ends).
                    </p>
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                  <div className="bg-gray-50 rounded-lg p-6">
                    <div className="flex items-center mb-3">
                      <Clock className="w-5 h-5 text-gray-600 mr-2" />
                      <h3 className="font-semibold text-gray-900">Business Hours</h3>
                    </div>
                    <p className="text-gray-600">
                      We are open from 9 am to 5 pm.
                    </p>
                  </div>

                  <div className="bg-gray-50 rounded-lg p-6">
                    <h3 className="font-semibold text-gray-900 mb-3">Contact Information</h3>
                    <div className="space-y-3">
                      <div className="flex items-center">
                        <Phone className="w-5 h-5 text-gray-600 mr-2" />
                        <a href="tel:909-990-9090" className="text-blue-600 hover:text-blue-800">
                          909‑990‑9090
                        </a>
                      </div>
                      <div className="flex items-center">
                        <Mail className="w-5 h-5 text-gray-600 mr-2" />
                        <a href="mailto:vholicllc@gmail.com" className="text-blue-600 hover:text-blue-800">
                          vholicllc@gmail.com
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="bg-yellow-50 rounded-lg p-6">
                  <h2 className="text-lg font-semibold text-yellow-900 mb-4">Need Help?</h2>
                  <p className="text-yellow-800">
                    For questions about service or products, contact us at{' '}
                    <a href="tel:909-990-9090" className="text-blue-600 hover:text-blue-800">909‑990‑9090</a>
                    {' '}or{' '}
                    <a href="mailto:vholicllc@gmail.com" className="text-blue-600 hover:text-blue-800">vholicllc@gmail.com</a>.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}